import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Show } from '../show';
import FluidContainer from '../layouts/components/fluid-container';
import WarningIcon from './assets/warning-icon.svg?react';

export const FallbackContainer = styled.div``;

const Icon = styled(WarningIcon)`
    width: 18px;
    height: 18px;
    fill: ${(props) => props.theme.colors['text-grey-700']};
    margin: ${(props) => props.theme.space.small}px;
`;

const FallbackWithText = styled(FluidContainer)`
    font-size: ${(props) => props.fontSize};
    text-align: center;
    letter-spacing: 0.37px;
    line-height: 16px;
    color: var(--gray700);
    background-color: var(--gray200);

    &:focus {
        outline: none;
    }
`;

export const FallbackPlaceholder = ({
    text = 'Errore nel caricamente della risorsa. Riprova.',
    justifyContent = 'flex-start',
    flexDirection = 'row',
    showIcon = true,
    fontSize = '14px',
    ...props
}) => {
    return (
        <FallbackWithText
            alignItems="center"
            flexDirection={flexDirection}
            flexWrap="nowrap"
            justifyContent={justifyContent}
            borderRadius={2}
            fontSize={fontSize}
            {...props}
        >
            <Show when={showIcon}>
                <Icon />
            </Show>

            {props.render ? props.render() : text}
        </FallbackWithText>
    );
};

FallbackPlaceholder.propTypes = {
    /** Text to show on Error event */
    text: PropTypes.string,
    fontSize: PropTypes.string,
    /** Css flex property */
    justifyContent: PropTypes.string,
    /** Css flex property */
    flexDirection: PropTypes.string,
    /** With warning icon or not */
    showIcon: PropTypes.bool,
    render: PropTypes.node,
};

const Fallback = React.forwardRef(({ src, as = 'img', children, text, ...props }, ref) => {
    const [isFallback, setFallback] = useState(false);

    useEffect(() => {
        setFallback(false);
    }, [src]);

    return (
        <>
            <Show when={!isFallback}>
                <FallbackContainer ref={ref} as={as} src={src} {...props} onError={() => setFallback(true)} width="100%" />
                {children}
            </Show>
            <Show when={isFallback}>
                <FallbackPlaceholder text={text} {...props} />
            </Show>
        </>
    );
});

Fallback.propTypes = {
    /** Component to hide on Fallback  */
    children: PropTypes.node,
    /** Remote source path  */
    src: PropTypes.string,
    /** Component DOM node  */
    as: PropTypes.oneOf(['img', 'audio']),
    /** Text to show on FallBackPlaceholder when Error event occur */
    text: PropTypes.string,
};

export default Fallback;
